// extracted by mini-css-extract-plugin
export var currencyInput = "_lb-1";
export var currencySymbol = "_lb-0";